import { Slider } from 'antd';
import styled from 'styled-components';

export const CustomSlider = styled(Slider)`
  width: 126px;
  border-radius: 999px;
  display: flex;
  align-items: center;
`;
